












































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { BasicSelect } from 'vue-search-select';
import {
  Component, Prop, PropSync,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AdminActions } from '@/store/admin/actions';
import { UserProject } from '@/store/users/types';
import IntegrityTable, { FillFunctionContainer, processDateWithTableObject } from '@/components/IntegrityTable/IntegrityTable.vue';
import IntegrityDelete from '@/components/IntegrityDelete/IntegrityDelete.vue';
import { UserPermission } from '@/store/userpermissions/types';
import { uuid } from 'vue-uuid';
import AdminPanelMixin, { EditUserData } from '../AdminPanelMixin.vue';

const adminModule = namespace('admin');

@Component({
  components: {
    BasicSelect,
    IntegrityTable,
    IntegrityDelete,
  },
})
export default class ProjectList extends AdminPanelMixin {
  @PropSync('user') readonly synchedSelectedUser: EditUserData;

  @Prop() readonly search!: string;

  @Prop() readonly hideDefaultFooter!: boolean;

  @Prop({ default: true }) readonly patchUserOnSave: boolean;

  @Prop({ default: true }) readonly start: boolean;

  @Prop({ default: false }) readonly canClearDate: boolean;

  @Prop({ default: 'scheduledStartTime' }) readonly scheduledStartTimePropKey: string;

  @Prop({ default: 'scheduledEndTime' }) readonly scheduledEndTimePropKey: string;

  @adminModule.Action(AdminActions.DELETE_USER_ROLE) deleteUserRoleAction;

  @adminModule.Action(AdminActions.PATCH_USER_ROLE) patchUserRoleAction;

  editDialogVisible = false;

  startDateMenu = false as boolean;

  endDateMenu = false as boolean;

  startDate = null as string | undefined;

  endDate = null as string;

  userRoleToEdit = {} as UserProject;

  userRoleToDelete = {} as UserProject;

  snackbarMessage = '';

  snackbarColor = '';

  snackbarVisible = false;

  allHeaders = [
    {
      text: 'Project Name',
      value: 'projectName',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Project Number',
      value: 'projectNumber',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Customer',
      value: 'projectCustomer',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Access Start Date',
      value: this.scheduledStartTimeKey,
      sortable: true,
      filterable: true,
    },
    {
      text: 'Access End Date',
      value: this.scheduledEndTimeKey,
      sortable: true,
      filterable: true,
    },
    {
      text: 'Actions',
      value: 'actions',
      align: 'left',
      sortable: false,
    },
  ];

  matchFilters = [
    {
      header: 'projectName',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'projectNumber',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'projectCustomer',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: this.scheduledStartTimeKey,
      type: 'date',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: this.scheduledEndTimeKey,
      type: 'date',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
  ];

  mounted(): void {
    if (!this.customerDataList || this.customerDataList.length <= 0) {
      this.fetchCustomerData();
    } if (!this.organizationProjects || this.organizationProjects.length <= 0) {
      this.fetchOrganizationProjectsData();
    }
  }

  get scheduledStartTimeKey(): string {
    return this.scheduledStartTimePropKey != null ? this.scheduledStartTimePropKey : 'scheduledStartTime';
  }

  get scheduledEndTimeKey(): string {
    return this.scheduledEndTimePropKey != null ? this.scheduledEndTimePropKey : 'scheduledEndTime';
  }

  get fillTableDataFunctions(): FillFunctionContainer {
    const returnValue: FillFunctionContainer = {
      updateKey: uuid.v4(),
      fillFunctions: [
        {
          headerValue: this.scheduledStartTimeKey,
          functionVariables: [this.scheduledStartTimeKey],
          fillFunction: processDateWithTableObject,
        },
        {
          headerValue: this.scheduledEndTimeKey,
          functionVariables: [this.scheduledEndTimeKey],
          fillFunction: processDateWithTableObject,
        },
      ],
    };
    return returnValue;
  }

  get filteredRoles(): any[] {
    return this.synchedSelectedUser?.detailedUserData?.userRoles != null
      ? this.synchedSelectedUser.detailedUserData.userRoles
      : undefined;
  }

  get headers(): any[] {
    let list = this.allHeaders;
    if (!this.hasPermissionAdminDeleteUser) {
      list = list.filter((item) => item.value !== 'delete');
    }
    if (!this.hasPermissionAdminSetDateRangeForActivation) {
      list = list.filter((item) => item.value !== 'edit');
    }
    return list;
  }

  editDialog(userRoleToEdit: UserProject): void {
    this.startDate = this.getDateString(userRoleToEdit.startDate);
    this.endDate = this.getDateString(userRoleToEdit.endDate);
    this.userRoleToEdit = userRoleToEdit;
    this.editDialogVisible = true;
    this.$forceUpdate();
  }

  async deleteUserRole(userRoleToDelete: UserProject): Promise<boolean> {
    try {
      const foundUserRoleIndex = this.synchedSelectedUser.detailedUserData.userRoles.findIndex(
        (value) => value.projectGuid === userRoleToDelete.projectGuid,
      );
      if (foundUserRoleIndex > -1) {
        this.synchedSelectedUser.detailedUserData.userRoles.splice(
          foundUserRoleIndex,
          1,
        );
        if (this.synchedSelectedUser.detailedUserData.userRoles.length <= 0) {
          this.$emit(
            'deleteUser',
            this.synchedSelectedUser.detailedUserData.guid,
          );
        }
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
    return true;
  }

  async editUserRole(userRoleToEdit: UserProject): Promise<void> {
    // eslint-disable-next-line no-param-reassign
    userRoleToEdit.startDate = !this.startDate
      ? null
      : new Date(this.startDate);
    // eslint-disable-next-line no-param-reassign
    userRoleToEdit.endDate = !this.endDate ? null : new Date(this.endDate);

    try {
      if (this.patchUserOnSave) {
        await this.patchUserRoleAction(userRoleToEdit);
      }
      const userRoleIndex = this.synchedSelectedUser.detailedUserData.userRoles.findIndex(
        (r) => r.guid === userRoleToEdit.guid,
      );
      this.synchedSelectedUser.detailedUserData.userRoles.splice(
        userRoleIndex,
        1,
        userRoleToEdit,
      );

      this.snackbarMessage = 'User role edited';
      this.snackbarColor = 'green';
    } catch (e) {
      this.snackbarMessage = (e as Error).message;
      this.snackbarColor = '#e61e25';
    }

    this.snackbarVisible = true;
    this.editDialogVisible = false;
  }

  getDateString(date: Date): string {
    return !date ? null : new Date(date).toISOString().substr(0, 10);
  }

  /**
   * @returns true if the user has the permission ADMIN_USER_SECTION_DELETEUSER
   */
  get hasPermissionAdminDeleteUser(): boolean {
    return this.hasPermission(UserPermission.ADMIN_USER_SECTION_DELETEUSER);
  }

  /**
   * @returns true if the user has the permission ADMIN_USER_SECTION_EDIT_PROJECT_ACCESS_DATES
   */
  get hasPermissionAdminSetDateRangeForActivation(): boolean {
    return this.hasPermission(UserPermission.ADMIN_USER_SECTION_EDIT_PROJECT_ACCESS_DATES);
  }
}
